module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kf-Lc.700ce618.png";